import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import ReactHtmlParser from 'react-html-parser';
import { getMediaPath } from '../../../app/functions';
import { reduceFontSizePxInHtml } from 'common/utils';
import theme from 'theme';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  gap: '0px',
  padding: '0px 24px',
  textAlign: 'center',
}));

const CategoriesRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '20px',
  paddingLeft: { xs: '10px' },
  paddingRight: { xs: '10px' },
}));

const CategoryItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  cursor: 'pointer',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'translateY(-5px)',
  },
}));

const Icon = styled('img')(({ theme }) => ({
  width: '50px',
  height: '50px',
  marginBottom: '10px',
  [theme.breakpoints.up('sm')]: {
    width: '75px',
    height: '75px',
  },
  [theme.breakpoints.up('md')]: {
    width: '100px',
    height: '100px',
  },
}));

const handleCategoryClick = (link) => {
    if (link) {
        window.location.href = link;
    }
}

const InterestsCategoriesSection = ({ data }) => {
  if (!data?.interestsCategories?.length) return null;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const processedHeaderText = isMobile ? reduceFontSizePxInHtml(data.interestsCategoriesHeaderText, 4) : data.interestsCategoriesHeaderText;
  return (
    <Container testID="interests-categories-section">
      <Typography gutterBottom style={{
        textAlign: 'center',
        paddingLeft: { xs: '10px' },
        paddingRight: { xs: '10px' },
      }}>
        {ReactHtmlParser(processedHeaderText)}
      </Typography>
      <CategoriesRow>
        {data.interestsCategories.map((category,index) => (
          <CategoryItem key={index} onClick={() => handleCategoryClick(category.link)} testID={`category-item-${index}`}>
            <Icon src={getMediaPath(category.image)} alt={category.title} />
            <Typography variant="body1">{ReactHtmlParser(category.title)}</Typography>
          </CategoryItem>
        ))}
      </CategoriesRow>
    </Container>
  );
};

InterestsCategoriesSection.propTypes = {
  data: PropTypes.shape({
    categories: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        iconPath: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
};

export default InterestsCategoriesSection; 